import { Component, OnDestroy } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-kb-vizseek-no-popup',
  templateUrl: './kb-vizseek-no-popup.component.html',
  styleUrls: ['./kb-vizseek-no-popup.component.scss'],
  standalone: false
})
export class KbVizseekNoPopupComponent implements OnDestroy {
  NOresults: string;
  subscription = new Subscription();
  constructor(private translationService: TranslationService) { }

  ngOnInit() {
    this.subscription.add(this.translationService.translate('common.vizseek_Search_NOresults_found')
      .subscribe((key) => {
        this.NOresults = this.splitLabel(key);
      }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  splitLabel(text: string): string {
    // Use regex to split text at "<br />" tag
    const regex = /<br\s*\/?>/i;

    const parts = text.split(regex);
    return parts.join('\n'); // Join parts with newline character
  }
}
